import { KeyModifiers } from 'chessboard/model/dom/types';

/**
 * Determine the key pressed with a mouse event.
 */
export function getKeyPressed(event: MouseEvent | PointerEvent | TouchEvent): string {
  if (event.altKey) {
    return KeyModifiers.Alt;
  }

  if (event.ctrlKey) {
    return KeyModifiers.Ctrl;
  }

  if (event.shiftKey) {
    return KeyModifiers.Shift;
  }

  return KeyModifiers.None;
}
